import { useEffect } from 'react';

type ResponsiveQuery = { size: number; className: string };

interface ResponsiveItem {
  wrapperId: string;
  targetId: string;
  queries: ResponsiveQuery[];
}

interface UseResponsiveProps {
  items: ResponsiveItem[];
}

const useResponsive = ({ items }: UseResponsiveProps) => {
  useEffect(() => {
    const script = document.createElement('script');
    script.setAttribute('keepexport', 'true');
    script.innerHTML = `
    (() => {
      const process = () => {
        ${items.map((item) => `makeResponsive("${item.wrapperId}", "${item.targetId}", ${JSON.stringify(
    item.queries,
  )})`)}
      }

      window.addEventListener('DOMContentLoaded', () => {
        process();
      });

      process();
    })();
    `;
    document.head.appendChild(script);
  }, [items]);
};

export default useResponsive;
